import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { viewImage } from "../../utils/viewPDF";
import { useNavigate } from "react-router-dom";

const MyBuyers = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const [buyers, setBuyers] = useState([]);
  const [filteredBuyers, setFilteredBuyers] = useState([]);
  const [logoUrls, setLogoUrls] = useState({});
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const getBuyers = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-org?vendorId=${vendorId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBuyers(res.data);
        setFilteredBuyers(res.data);
        setIsLoading(false);

        const logoFetches = await Promise.all(
          res.data.map(async (buyer, index) => {
            if (buyer.organization.orgLogo) {
              const url = await viewImage(
                buyer.organization.orgLogo,
                storedUser
              );
              return { index, url };
            }
            return { index, url: null };
          })
        );

        const logoMap = {};
        logoFetches.forEach(({ index, url }) => {
          logoMap[index] = url;
        });
        setLogoUrls(logoMap);
      } catch (error) {
        console.log(error);
      }
    };
    getBuyers();
  }, []);

  useEffect(() => {
    const lowercasedSearch = searchText.toLowerCase();

    const newFilteredBuyers = buyers.filter((buyer) => {
      const orgName = buyer?.organization?.orgName?.toLowerCase() || "";
      return orgName.includes(lowercasedSearch);
    });

    setFilteredBuyers(newFilteredBuyers);
  }, [searchText, buyers]);

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">My Buyers List</Typography>
        <TextField
          placeholder="Search Buyer"
          size="small"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{
            borderRadius: "12px",
            background: "#fff",
            width: 300,
            "& .MuiOutlinedInput-root": { borderRadius: "12px" },
            "&:hover": { background: "#D8E9F0" },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {!isLoading ? (
        filteredBuyers.length > 0 ? (
          filteredBuyers.map((buyer, i) => (
            <Box
              sx={{
                display: "flex",
                gap: 1,
                mb: 2,
                "&:hover .child-box": {
                  cursor: "pointer",
                  background: "#EBF1F8",
                },
              }}
              key={buyer.organization.orgId}
              onClick={() =>
                navigate(`/vendor/dashboard/buyers/${buyer.organization.orgId}`)
              }
            >
              <Box
                className="dashboard-container child-box"
                sx={{ flex: 0.2, boxShadow: "0px 3px 12.3px 0px #CCE0FF" }}
              >
                {logoUrls[i] ? (
                  <img
                    src={logoUrls[i]}
                    alt="Org Logo"
                    style={{ width: "100%", height: "auto" }}
                  />
                ) : (
                  <span>Loading...</span>
                )}
              </Box>
              <Box
                className="dashboard-container child-box"
                sx={{ flex: 1, boxShadow: "0px 3px 12.3px 0px #CCE0FF" }}
              >
                <Typography variant="h5" fontWeight={700}>
                  {buyer.organization.orgName}
                </Typography>
              </Box>
            </Box>
          ))
        ) : (
          <Box sx={{ textAlign: "center", my: 10 }}>
            <Typography>
              Once you qualify technically in one bid of a buyer, all tenders
              from that buyer will be visible to you.
            </Typography>
            <Button
              className="btn-contained"
              onClick={() => {
                localStorage.setItem("active", 1)
                navigate("/vendor/dashboard")}}
            >
              Go To Dashboard
            </Button>
          </Box>
        )
      ) : (
        <Typography>Loading...</Typography>
      )}
    </div>
  );
};

export default MyBuyers;
